import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import PhpackagingmaterialFilterCriteria from './PhpackagingmaterialFilterCriteria'
import PhpackagingmaterialList from './PhpackagingmaterialList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './PhpackagingmaterialAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setPhpackagingmaterialDashboardPhpackagingmaterialList } from '../../store/slice/PharmaSlice';

export default function PhpackagingmaterialListView({setShowEdit,setPhpackagingmaterialId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.phpackagingmaterialDashboard);   

    const [filteredPhpackagingmaterialList, setFilteredPhpackagingmaterialList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { phpackagingmaterialDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (phpackagingmaterialDashboard.phpackagingmaterialList.length>-1){
        setFilteredPhpackagingmaterialList(phpackagingmaterialDashboard.phpackagingmaterialList);
        transformToCardFormat(phpackagingmaterialDashboard.phpackagingmaterialList, setCardList);
      }
    },[phpackagingmaterialDashboard.phpackagingmaterialList])

    useEffect(()=>{
          transformToCardFormat(filteredPhpackagingmaterialList, setCardList);
      },[filteredPhpackagingmaterialList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.formid==='' && filterCriteria.formname==='' ){
            setFilteredPhpackagingmaterialList(phpackagingmaterialDashboard.phpackagingmaterialList);
            transformToCardFormat(phpackagingmaterialDashboard.phpackagingmaterialList, setCardList);

        } else {
            setFilteredPhpackagingmaterialList(
                phpackagingmaterialDashboard.phpackagingmaterialList
                    .filter(phpackagingmaterial=> phpackagingmaterial.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))
.filter(phpackagingmaterial=> phpackagingmaterial.formid.toString().toUpperCase().includes(filterCriteria.formid.toString().toUpperCase()))
.filter(phpackagingmaterial=> phpackagingmaterial.formname.toString().toUpperCase().includes(filterCriteria.formname.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(phpackagingmaterialDashboard.filteredPhpackagingmaterialList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <PhpackagingmaterialList
                    setShowEdit={setShowEdit}
                    setPhpackagingmaterialId = {setPhpackagingmaterialId}
                    tableList={filteredPhpackagingmaterialList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}